import { UPDATE_SIGNATURE_EXECUTOR,
     UPDATE_SIGNATURE_EXECUTOR_FAIL,
      UPDATE_SIGNATURE_EXECUTOR_SUCCESS,
      RESET_EXECUTOR_FLAG, 
      SEND_SMS_PAYMENT,
      SEND_SMS_PAYMENT_SUCCESS,
      SEND_SMS_PAYMENT_FAIL,
      GET_LIST_EXECUTOR,
      GET_LIST_EXECUTOR_SUCCESS,
      GET_LIST_EXECUTOR_FAIL,
      GET_LIST_EXECUTOR_FILTER,
      INACTIVE_EXECUTOR,
      INACTIVE_EXECUTOR_SUCCESS,
      INACTIVE_EXECUTOR_FAIL,
      UPSERT_EXECUTOR,
      UPSERT_EXECUTOR_SUCCESS,
      UPSERT_EXECUTOR_FAIL,
      FILTER_LOADING,
      FILTER_EXECUTOR} from "./actionTypes";


  //-----------------------------------------------------Upsert Executor
  export const upsertExecutor = (data) =>({
    type:UPSERT_EXECUTOR,
    payload: data
})

export const upsertExecutorSuccess = event =>({
    type:UPSERT_EXECUTOR_SUCCESS,
    payload:event
})
export const upsertExecutorFail = error =>({
    type:UPSERT_EXECUTOR_FAIL,
    payload:error
})

//-----------------------------------------------------Signature
export const updateSignatureExecutor = events =>({
    type:UPDATE_SIGNATURE_EXECUTOR,
    payload:events
})

export const updateSignatureExecutorSuccess = events =>({
    type:UPDATE_SIGNATURE_EXECUTOR_SUCCESS,
    payload:events
})
export const updateSignatureExecutorFail = error =>({
    type:UPDATE_SIGNATURE_EXECUTOR_FAIL,
    payload:error
})

//-----------------------------------------------------get List Executor
export const getListExecutor = () =>({
    type:GET_LIST_EXECUTOR
})

export const getListExecutorFilter = (filter) =>({
    type:GET_LIST_EXECUTOR_FILTER,
    payload: filter
})

export const getListExecutorSuccess = events =>({
    type:GET_LIST_EXECUTOR_SUCCESS,
    payload:events
})
export const getListExecutorFail = error =>({
    type:GET_LIST_EXECUTOR_FAIL,
    payload:error
})

//-----------------------------------------------------send Sms Payment
export const sendSmsPayment = events =>({
    type:SEND_SMS_PAYMENT,
    payload:events
})

export const sendSmsPaymentSuccess = () =>({
    type:SEND_SMS_PAYMENT_SUCCESS
})
export const sendSmsPaymentFail = error =>({
    type:SEND_SMS_PAYMENT_FAIL,
    payload:error
})

//-----------------------------------------------------Inactive
export const inactiveExecutor = exeId =>({
    type:INACTIVE_EXECUTOR,
    payload:exeId
})

export const inactiveExecutorSuccess = events =>({
    type:INACTIVE_EXECUTOR_SUCCESS,
    payload:events
})
export const inactiveExecutorFail = error =>({
    type:INACTIVE_EXECUTOR_FAIL,
    payload:error
})


//------------------------------------------------------Filter

export const filterExecutor = (data) =>({
    type:FILTER_EXECUTOR,
    payload: data
})
//------------------------------------------------------Filter loading

export const filterExecutorLoading = (data) =>({
    type:FILTER_LOADING,
    payload: data
})
//-----------------------------------------------------Reset
export const resetExecutorFlag = () => {
    return {
        type:RESET_EXECUTOR_FLAG
    }
}